

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-heart-fill',
      title: 'Furnished Rentals',
      description: 'Flexible, fully furnished homes for professionals, families, and travelers.',
      image: 'https://public.readdy.ai/ai/img_res/d022fe50aca5ed98caa5710a12506ab0.jpg',
      stats: '4.8 Star Rating'
    },
    {
      icon: 'ri-building-2-fill',
      title: 'Property Management & Consulting',
      description: 'Stress-free management and expert consulting for property owners.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20consultation%20meeting%20with%20exactly%204%20people%20in%20casual%20business%20attire%2C%202%20white%20professionals%20one%20male%20one%20female%2C%201%20Asian%20professional%2C%20and%201%20black%20professional%2C%2050%2F50%20male%20and%20female%20ratio%2C%20modern%20conference%20room%20with%20large%20photo%20of%20beautiful%20house%20displayed%20on%20wall%20in%20background%2C%20relaxed%20professional%20atmosphere%20with%20polo%20shirts%20and%20casual%20clothing%2C%20diverse%20team%20discussing%20property%20management%2C%20bright%20natural%20lighting%2C%20comfortable%20meeting%20space%2C%20approachable%20real%20estate%20professionals&width=400&height=300&seq=service-4-people-diverse-consultation&orientation=landscape',
      stats: '98% Satisfaction'
    },
    {
      icon: 'ri-line-chart-fill',
      title: 'Investment Guidance',
      description: 'Smart financing and connections to help investors scale their portfolios.',
      image: 'https://readdy.ai/api/search-image?query=Bright%20dynamic%20real%20estate%20investment%20visualization%20with%20modern%20financial%20charts%2C%20growth%20graphs%2C%20calculator%20and%20documents%2C%20investment%20portfolio%20analysis%2C%20professional%20financial%20planning%20meeting%2C%20contemporary%20office%20with%20city%20skyline%2C%20success%20metrics%20dashboard%2C%20well-lit%20bright%20environment&width=400&height=300&seq=service-bright-3&orientation=landscape',
      stats: 'Advised $400M Worth of Properties'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Host Toolkit',
      description: 'Digital products and templates to streamline your hosting operations.',
      image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20digital%20toolkit%20interface%20on%20laptop%20screen%20showing%20welcome%20guidebook%20templates%2C%20cleaning%20checklists%2C%20automated%20messaging%20systems%2C%20professional%20hosting%20tools%20dashboard%2C%20contemporary%20workspace%20with%20digital%20resources%2C%20sleek%20design%20elements%2C%20well-lit%20bright%20office&width=400&height=300&seq=service-bright-4&orientation=landscape',
      stats: 'New Offering'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Subtle background decorations */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-slate-100/50 rounded-full blur-3xl -translate-x-36 -translate-y-36"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-gray-100/50 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-4 py-2 bg-slate-100 text-slate-700 rounded-full text-sm font-semibold mb-6">
            <i className="ri-star-fill mr-2"></i>
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            What We Do
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Comprehensive solutions for property owners, investors, and guests seeking quality furnished accommodations.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group relative bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 border border-slate-200 flex flex-col">
              {/* Image with subtle overlay */}
              <div className="relative h-48 overflow-hidden">
                <div className="absolute inset-0 bg-cover bg-center transform group-hover:scale-105 transition-transform duration-700" style={{ backgroundImage: `url('${service.image}')` }}></div>
                <div className="absolute inset-0 bg-slate-900/20 group-hover:bg-slate-900/10 transition-all duration-300"></div>
                
                {/* Stats badge */}
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-slate-700 shadow-sm">
                  {service.stats}
                </div>
              </div>
              
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mr-4 shadow-sm">
                    <i className={`${service.icon} text-xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 group-hover:text-slate-700 transition-colors duration-300">{service.title}</h3>
                </div>
                <p className="text-slate-600 leading-relaxed mb-6 flex-grow">{service.description}</p>
                
                {/* Learn more link */}
                <div 
                  className="flex items-center text-slate-700 font-semibold group-hover:text-slate-900 transition-colors duration-300 cursor-pointer mt-auto"
                  onClick={() => {
                    const contactSection = document.getElementById('contact');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  <span className="mr-2">Learn More</span>
                  <i className="ri-arrow-right-line transform group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
              </div>
              
              {/* Hover effect border */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-slate-300 rounded-xl transition-colors duration-300"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

